export const currency = localStorage.getItem('country') == 'Ghana' ? 'GHS' : 'NGN';
export const appMessages = {
    enterPickupLocation : `Alert! Please enter your pickup location.`,
    enterDropOffLocation : `Alert! Please enter your drop-off location.`,
    selectDeliveryMethod : `Vehicle! Please select delivery method to Proceed further.`,
    noEnoughBalance : `Alert! You don't have enough balance to pay using wallet! Please fund your wallet or proceed to pay with cash or online payment.`,
    invalidPromoCode :  `Promotion provided promo is not available. Please provide a valid promocode.`,
    expiredPromo : `Promotion provided promo is not valid or expired. Please provide a valid promocode.`,
    selectHandlingItem : `Alert! Please select your handling item.`,
    selectPaymentmethod : `Alert! Please select your preferred payment method.`,
    cashOnServiceType : `Alert! Please select your Cash on Service method.`,
    packageSizeEmpty :  'Please select your package size',
    loadingFeeInfo : `A nominal flat rate fee will be instituted to duly compensate the driver and their dedicated team for their commendable efforts.`,
    noEnoughPhlenuCase : `You must have at least 1 ${currency} phlenu cash in your wallet to apply.`,
    plenuCaseUnavailable : `Phlenu cash not available!`,
    selectItemWeightCate : `Alert! Please select your item weight category`,

    // bulk
    enterReceiverName : `Alert! Please enter receiver name`,
    enterContactNumber : `Alert! Please enter contact number`,
    selectPackageSize : `Alert! Please select package size`,
    promoUnavailable : `Promotion! 'Provided promo is not available. Please provide a valid promocode.`,
    promoInvalidOrExpired : `Promotion! 'Provided promo is not valid or expired. Please provide a valid promocode.`,
    removeDropOff : `Are you sure you want to delete this drop off?`,
    
}